import { orgRoleHasCapability, requiresProjectAssignment, type OrgRole } from "./orgRoles";

/**
 * What the UI may offer a role, each flag mirroring the server check that enforces it. Commercial
 * access is separate (`getEffectiveAccessState`); these never imply the organization can write.
 */
export function getViewerCapabilities(role: OrgRole) {
  const canEditWork = orgRoleHasCapability(role, "edit_work");
  const canManageMembers = orgRoleHasCapability(role, "manage_members");
  return {
    canEditWork,
    // projects.create and projects.remove are projectWriteMutations that also call assertOrgManager.
    canCreateProjects: canEditWork && canManageMembers,
    canManageMembers,
    canManageBilling: orgRoleHasCapability(role, "manage_billing"),
    canDownloadExports: orgRoleHasCapability(role, "download_completed_exports"),
    requiresProjectAssignment: requiresProjectAssignment(role),
  };
}

export type ViewerCapabilities = ReturnType<typeof getViewerCapabilities>;
